import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */

export const ACTION_GET_ELIGIBILITY_CRITERIA = 'ACTION_GET_ELIGIBILITY_CRITERIA'
export const ACTION_SEARCH_ELIGIBILITY_CRITERIA = 'ACTION_SEARCH_ELIGIBILITY_CRITERIA'
export const ACTION_DELETE_ELIGIBILITY_CRITERIA = 'ACTION_DELETE_ELIGIBILITY_CRITERIA'
export const ACTION_UPDATE_ELIGIBILITY_CRITERIA = 'ACTION_UPDATE_ELIGIBILITY_CRITERIA'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_SEARCH_ELIGIBILITY_CRITERIA:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_ELIGIBILITY_CRITERIA:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_ELIGIBILITY_CRITERIA:
		case ACTION_UPDATE_ELIGIBILITY_CRITERIA:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const searchEligibilityCriteria = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/searchEligibilityCriteria',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			let resp = response.data.map(i=>{
				if (i.id) {
					i.status = i.deleted ? 2 : 1
					if(i.tipoEvaluacion && i.tipoEvaluacion.evaluacion) {
						i.evaluacionDesc = i.tipoEvaluacion.evaluacion
					}
					if(i.variable && i.variable.variable) {
						i.variableDesc = i.variable.variable
					}
					return i
				}
			})

			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_ELIGIBILITY_CRITERIA, Obj: resp })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const getEligibilityCriteria = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getEligibilityCriteria',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			if (response.data.idCriteriosElegibilidad) {
				response.data.id = response.data.idCriteriosElegibilidad
				response.data.criterio = response.data.criteriosElegibilidad
				response.data.status = response.data.deleted ? 2 : 1
				if(response.data.tipoEvaluacion && response.data.tipoEvaluacion.evaluacion) {
					response.data.evaluacionDesc = response.data.tipoEvaluacion.evaluacion
				}
				if(response.data.variable && response.data.variable.variable) {
					response.data.variableDesc = response.data.variable.variable
				}
			}
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_ELIGIBILITY_CRITERIA, Obj: response.data })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const newEligibilityCriteria = (form) => {

	Utils.clearNullAndEmpty(form)

	const tmp = {
		"autor": sessionStorage.uid,
		"autorUltimaModificacion": "",
		"criterio": form.criterio,
		"cumplimiento": form.cumplimiento,
		"deleted": form.status !== 1,
		"descripcion": form.descripcion,
		"fechaCreacion": new Date().toISOString().slice(0,10),
		"fechaUltimaModificacion": "",
		"idVariable": form.idVariable,
		"idTipoEvaluacion": form.idTipoEvaluacion,
		"id": form.id,
		"idTipoCriterio": form.idTipoCriterio,
		"regla": form.regla
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newEligibilityCriteria',
			method: "POST",
			data: tmp,
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_ELIGIBILITY_CRITERIA, Obj: response.data })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const updateEligibilityCriteria = (form) => {

	Utils.clearNullAndEmpty(form)

	const tmp = {
		"autor": sessionStorage.uid,
		"criterio": form.criterio,
		"cumplimiento": form.cumplimiento,
		"deleted": form.status !== 1,
		"descripcion": form.descripcion,
		"fechaUltimaModificacion": new Date().toISOString().slice(0,10),
		"idVariable": form.idVariable,
		"idTipoEvaluacion": form.idTipoEvaluacion,
		"id": form.id,
		"idTipoCriterio": form.idTipoCriterio,
		"regla": form.regla
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/updateEligibilityCriteria',
			method: "POST",
			data: {...tmp},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_ELIGIBILITY_CRITERIA, Obj: response.data })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const deleteEligibilityCriteria = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/deleteEligibilityCriteria',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_DELETE_ELIGIBILITY_CRITERIA, Obj: response.data })
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			return error
		})
	}
}

export const clearEligibilityCriteria = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_ELIGIBILITY_CRITERIA, Obj: {}})
		dispatch({ type: ACTION_SEARCH_ELIGIBILITY_CRITERIA, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Catalogs/EligibilityCriteria/EligibilityCriteria.js